// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const ACCOUNT_INITIALIZE = 'ACCOUNT_INITIALIZE';

// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';

// action - UI states REDUCER

export const START_EDITING_PI = '@uiStates/START_EDITING_PI';
export const STOP_EDITING_PI = '@uiStates/STOP_EDITING_PI';
export const START_EDITING_ADDR = '@uiStates/START_EDITING_ADDR';
export const STOP_EDITING_ADDR = '@uiStates/STOP_EDITING_ADDR';
export const START_EDITING_ID = '@uiStates/START_EDITING_ID';
export const STOP_EDITING_ID = '@uiStates/STOP_EDITING_ID';
